import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { handleExport } from '../../../../helpers/export'
import portfolioScoreService from '../../core/service'

export const getDistributionCreditRisk = createAsyncThunk(
  'portfolioInsights/score/portfolioDistribution/getDistributionCreditRisk',
  async (params, { rejectWithValue }) => {
    try {
      const res = await portfolioScoreService.getDistributionCreditRisk(params)
      return res.success ? res.data : rejectWithValue(res.errors)
    } catch (err) {
      return rejectWithValue({ loading: axios.isCancel(err) })
    }
  },
)

export const getDistributionPerformance = createAsyncThunk(
  'portfolioInsights/score/portfolioDistribution/getDistributionPerformance',
  async (params, { rejectWithValue }) => {
    try {
      const res = await portfolioScoreService.getDistributionPerformance(params)
      return res.success ? res.data : rejectWithValue(res.errors)
    } catch (err) {
      return rejectWithValue({ loading: axios.isCancel(err) })
    }
  },
)

export const exportDistributionCreditRisk = createAsyncThunk(
  'portfolioInsights/score/portfolioDistribution/exportDistributionCreditRisk',
  async (params) => {
    const response = await portfolioScoreService.exportDistributionCreditRisk(
      params,
    )
    handleExport(response.data, response.filename)
  },
)

export const exportDistributionPerformance = createAsyncThunk(
  'portfolioInsights/score/portfolioDistribution/exportDistributionPerformance',
  async (params) => {
    const response = await portfolioScoreService.exportDistributionPerformance(
      params,
    )
    handleExport(response.data, response.filename)
  },
)
